import { render } from "./regler.vue?vue&type=template&id=0881aa46&ts=true"
import script from "./regler.vue?vue&type=script&lang=ts"
export * from "./regler.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__